const setProp = (propName, propValue) => ({ [propName]: propValue });

setProp.setsComponentProperties = true;

export {
  // eslint-disable-next-line import/prefer-default-export
  setProp
};
